import React, { useState } from 'react';
import { Button, Form, Alert } from 'react-bootstrap';
import { useAuthContext } from 'contexts/AuthContext';
import { registerUser } from 'helpers/requests/users';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { setFormErrors } from 'helpers/errors';
import { handleUnexpectedStatusCode } from 'helpers/errors';

const RegistrationForm = ({ next }) => {
  const [submittingForm, setSubmittingForm] = useState(false);
  const { setIsAuthenticated } = useAuthContext();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError
  } = useForm();

  const submitForm = async data => {
    setSubmittingForm(true);
    const r = await registerUser(data.full_name, data.email, data.password);
    if (r.success) {
      setIsAuthenticated(true);
      navigate(next);
    } else {
      if (r.response.status === 400) {
        setFormErrors(r.response.data, setError);
      } else {
        handleUnexpectedStatusCode(r.expectedStatusCode, r.response.status);
      }
    }
    setSubmittingForm(false);
  };

  return (
    <Form noValidate onSubmit={handleSubmit(submitForm)}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={'Full name'}
          name="full_name"
          type="text"
          isInvalid={!!errors.full_name}
          {...register('full_name', {
            required: 'Enter your full name'
          })}
        />
        <Form.Control.Feedback type="invalid">
          {errors.full_name?.message}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Control
          placeholder={'Email address'}
          name="email"
          type="text"
          isInvalid={!!errors.email}
          {...register('email', {
            required: 'Enter your email address',
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: 'Enter a valid email address'
            }
          })}
        />
        <Form.Control.Feedback type="invalid">
          {errors.email?.message}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Control
          placeholder={'Password'}
          name="password"
          type="password"
          isInvalid={!!errors.password}
          {...register('password', {
            required: 'Enter your password',
            minLength: {
              value: 6,
              message: 'Password must be at least 6 characters'
            }
          })}
        />
        <Form.Control.Feedback type="invalid">
          {errors.password?.message}
        </Form.Control.Feedback>
      </Form.Group>

      {errors.root?.nonFieldError?.message && (
        <Alert variant="danger">{errors.root.nonFieldError.message}</Alert>
      )}

      <Form.Group>
        <Button className="w-100" type="submit" disabled={submittingForm}>
          Register
        </Button>
      </Form.Group>
    </Form>
  );
};

export default RegistrationForm;
